import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../assets/p1.png';
import img2 from '../../assets/p2.png';
import img3 from '../../assets/p3.png';
import img4 from '../../assets/p4.png';
const Work = () => {
    return (
        
            
    <section className="dark:bg-gray-800 dark:text-gray-100 bg-base-200">
      
	<div className="container px-6 py-12 mx-auto">
    <h2 className='text-5xl font-bold text-center pt-16'>My Recent Works</h2>
		<div className="grid items-center gap-4">
			
			<div className="p-6 xl:col-span-3">
				<div className="grid gap-4 md:grid-cols-2">
					<div className="grid content-center gap-4">
						<div className="p-6 rounded shadow-md dark:bg-gray-900 ">
                        
                        <figure><img src={img1} alt="Shoes" /></figure>
                        <div className="card-body">
                            <h2 className="card-title text-3xl font-semibold justify-center">Tree-Pagla</h2>
                            {/* <p className='text-center'>If a dog chews shoes whose shoes does he choose?</p> */}
                            <div className="card-actions justify-center">
                            <Link to="/tree-pagla"><button className="btn ">Details</button></Link>
                            </div>
                        </div>
						</div>
						<div className="p-6 rounded shadow-md dark:bg-gray-900 ">
                        
                        <figure><img src={img4} alt="Shoes" /></figure>
                        <div className="card-body">
                            <h2 className="card-title text-3xl font-semibold justify-center">Daily Life</h2>
                            {/* <p className='text-center'>If a dog chews shoes whose shoes does he choose?</p> */}
                            <div className="card-actions justify-center">
                            <Link to="/daily-life"><button className="btn ">Details</button></Link>
                            </div>
                        </div>
						</div>
					</div>
					<div className="grid content-center gap-4">
						<div className="p-6 rounded shadow-md dark:bg-gray-900">
                        <figure><img src={img2} alt="Shoes" /></figure>
                        <div className="card-body">
                            <h2 className="card-title text-3xl font-semibold justify-center">Book Express</h2>
                            {/* <p className='text-center'>If a dog chews shoes whose shoes does he choose?</p> */}
                            <div className="card-actions justify-center">
                            <Link to="/book-express"><button className="btn ">Details</button></Link>
                            </div>
                        </div>
						</div>
						<div className="p-6 rounded shadow-md dark:bg-gray-900">
                        <figure><img src={img3} alt="Shoes" /></figure>
                        <div className="card-body">
                            <h2 className="card-title text-3xl font-semibold justify-center">IQ-Shake</h2>
                            {/* <p className='text-center'>If a dog chews shoes whose shoes does he choose?</p> */}
                            <div className="card-actions justify-center">
                            <Link to="/iq-shake"><button className="btn ">Details</button></Link>
                            </div>
                        </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    
</section>
    );
};

export default Work;